import * as React from "react";
import StoreContainer from "../stores/StoreContainer";

export default function CobrowseInfoBar() {
  return (
    <div className="velaro-cobrowse-bar">
      <span>You are currently sharing your screen.</span>
      <a
        onClick={() => {
          StoreContainer.CobrowseStore.requestStop();
        }}
        style={{ float: "right" }}
        className="velaro-link"
      >
        Stop sharing
      </a>
    </div>
  );
}
